export default class EventBridge {
  static emit(eventName) {
    try {
      EmitNative.postMessage(eventName);
    } catch (err) {
    }
  }
}
